var _style, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyLogoBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1226 553",
    style: {
      enableBackground: "new 0 0 1226 553"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#XMLID_6_);}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#085AAF;}\n\t.st3{fill:url(#XMLID_9_);stroke:#FFF811;stroke-width:0.25;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:url(#XMLID_10_);stroke:#FFF811;stroke-width:0.25;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:url(#SVGID_2_);}\n\t.st6{fill:url(#SVGID_3_);}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.8719,
    y1: 124.2889,
    x2: 774.8719,
    y2: 454.2877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#70FFDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0663307,
    style: {
      stopColor: "#5ADCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    style: {
      stopColor: "#43B7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    style: {
      stopColor: "#2F98BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3438,
    style: {
      stopColor: "#1E7EB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4534,
    style: {
      stopColor: "#126AAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    style: {
      stopColor: "#095CA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7314,
    style: {
      stopColor: "#0453A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    style: {
      stopColor: "#0251A5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M1059.9,446h-725c-1.1,0-2.1-0.9-2.1-2.1V123.3c0-1.1,0.9-2.1,2.1-2.1h725 c86.8,0,157.1,70.3,157.1,157.1V289C1217,375.7,1146.6,446,1059.9,446z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.5
    },
    width: 520,
    height: 519,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAggAAAIHCAYAAAD6qqS2AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAOEJJREFUeNrs3Yd6G0eWt/EiSIlU liznMDthw33she99bPh2Zu2Z8Vi2ZeVIUR/bqmMUiw2gQSJ0N37v87RBQTQJgqTqxf+cOpUSAABA xZ6nABgu/3br3/d6+rv8vvnPfz79j/e+SwBBALC5RX9vzrVtMZh1kQmAIAC4gAR0XfTjvsnptV9c ky1LQojAyen1rrhOZkhCF5kgDwBBAHZeAiYdF/1SDq7m68rpdVC8/7YEoZGB49Pr7en1Jl+lJHSR iRPyABAEYIwyEG9PlpCA8r5Fi/5efr/m7w9Pr+v59kq+fxspQize77IcvD69XuTbt/n+9x1lohSF LvJwUj0G0gAQBKB3MjCpFvyDjhIQ79tl0Z/k972a3+9Wvr1aCMU2iAX/TZaDp/n2Tb7/pKNMHOe/ 6yIPx9V9J6QBIAjAtoRglgxcqRb6K8UiP08CrrbcP2vR3+uYIGyDLgnC+wUyUUrCmw7yEPeXf/d2 jjQQBoAgACsVgjoBaJOBoyIZOMx/7iIBpURc7bDo7xUpwpXq/frQg/CuWryPU3sPQptMvKkW/y7y 8Kr4f9/kP8+ShjZxIAwAQQAuJAQHxWJcCsBhiwxcy1fz9o0lJKAtYZi16I9hF8M8mXjXIgnz5OF5 fvtlvmppeF0JRHyeY8IAEATgskJwLUvAUX77xgwZuNEiCl0koK1PYd6iP/Q5CIt2MbxbQh5KMXg+ Qxqe59tX+XpJGACCAIQUXFQImkX+Zl78b2YRuD1DBo6KZOFq/nMXCZhccNHv9STFtHhA0qzrpKM8 vCoW+tf5z23S8CSLw7P852dF0rC0MJAFEARgXCnBfjrfN9BVCO7k27g/EoQ2GajTgmUlYG/Hfj/b ZKKrPNSpQps0RIIQYtCIwuMlhaFMMN5JF0AQgHGlBGXvQAjBtY5CcLNICOKqtyleqWRgQgI2Ig8n lTS8Tee3Sb4qrheVGMwThpeFMJS9DNIFEARgYFIwKyWIpsB49R+Lf1chuJbOzy44aJGBScvi7/ds M/JQbmUsF+7jdH6mwsslhCHuixSibJqcmy6QBRAEYPNSkFL71sO2lOB6vhoJuJ1v7+W3lxWCtoSA DPRfGuqyxDLC0PQv/JKl4Um+fZGmJYk6XWjbUqkMAYIAbCAtiMW53A0QWw2jcfBmlRLczlJQSsL1 dLbU0FUIyMBwpWFZYYhGx1IOfslvl+lClCSep+kWy3oOxIlUAQQBWL0UlCWE6CeIhT1SgEYI7ubF v04JQhhuFBJxSAgIQwdheF0s/s/T2dJDmS4016M0LUc8K0Sj7ltQggBBAC4oBSnNLiFE2eBWIQJ3 8+39/HaZElwvZKIccEQI0FUYyoFLsei/qNKFRg5+zsLwqBCHmAQZoqAEAYIAXDAtWFRCiDkE9/P1 yen1URaDu0WiUKcE5Y6DfUKAJYThXTq/nbJOF55lMWiuh6fXj1kYfk7TOQxKECAIwCXSgkUlhLtZ CD4pJOF2mpYQjjqmBH7+0VUYuqQLr9K0BPGkkIMfszCEPHQpQUgVQBAgLWhJCxaVEMo/x/bEKCNE WiAlwKbThXLmQpwTEU2NUXJYVIKQKoAgQFowJy0IMZhVQoik4Gaa7kKo0wIpAbaRLpSpQuyCeFYk C7NKEOXcBakCCAJ2Li3YS+cPK2pLC+4VYjCvhFAegtTWZAhsQxbKAU1xqNSiEkQkC4tShXfJDggQ BIxQDOpdCLPSgvuFKHQpIUz8PKNnopBS++FSs0oQv1SyUKcKbbsgiAIIAkYjBjHqOLYgfjQjLSjH HishYAypwqISRMhCW6rwME23UsaoZ6IAgoBRiUE0FjYy8PHp9emCtEAJAWOUhbYSxLxU4cHp9VOW hmhwrEVBQyMIAnotBrGIzxKDT/P1eSEJXdICJQSMTRRSat8u2ZYqhBz8I8vCgzTtVYimRg2NIAjo pRiUJyheTdPdCHcqMfgi336SpmOQb0gLIFWYmSo0SUGMc/4xy8H3+TYShSg9aGgEQUCvEoOQgjg9 8XohBp9UYvBpmpYSIjGQFgDzU4VIFKL0ECnCP7Ik/JQWNzSekAQQBGxKDPbTdEdCOf64KSd8nOXg 80oM7qbpCOTYjSAtAOanCrH7IUY6PyoShZ+yLNQNjY/TtE/hdZkoEAUQBKxDDMrmw8M03ab4UZaC +/n2s0ISZonBfrITAegiCu/T2W2SIQpx/PTDdLah8cc0He/8S04Wok/ht9MkiQIIAlYtBtF8WIrB F2laRrifplMPbxMDYG2iEDsf6obG6FP4R76iBPEsTXsU9CeAIGDlYhC7Eu7npKApI3yVBSFmGNxO 7YONiAGwOlGY1dDYJAc/ZEn46+n1tyJRiAmN5iiAIOBCcjBJ8+cYfJrl4MssCJ+l6TjkEIPyaGVi AKxWFBraGhojUYizHv6WJeH7LA1NGaJtjgJRAEHAwtQgtisepuk45HqOwReFJMQ0xNiVUG9V9HMG rD9VKBsaI02IkkOUGv6eJSHmKMwSBTse4B9uzNyZ0Cz0t/LC/1EWgbbtinezGFzPQlHPMACweVF4 l6bbI5+m6e6GkIOYo1CKQmyPtOMBBIEYzN2Z0PQRNM2Hn+fry0IS5u1KIAZAP0Qhyg6v07TsENsj H1Si8EOy4wEt7HsKdlYOYsjRYZEYRFrw9en1x9PrX06vfz69/nB6fZOmjYghCNGESA6A/rzoK8ee x9HqR/n3/EZ+ERDHp0dp8HDe7/HHh39IP7/5s2dXgoAdSA1m9RnEzoQvsiQ0uxM+yeJwK9muCAwx TZg1R6FJFH5O7Tsefk7THQ/KDhIE7EhqEKWE2JUQvQX/lJOCJjH4U377qzQtK9xsSQykBkD/04Qy MYzR6JEoXE/TXUpxJsph8b717/d7aYIEAeNNDY6KxKCtz6DcmXArTc9LKONHPzfAOBKFJh2Icx5i x8P3OUmIYUs/pWkj4ytpggQB400NFvUZNLIQA4+ipGB3AjC+RKE8gbU8bO1mkSzEi4MoKb6XJkgQ MN7U4JOcFnyVhSDKCLP6DEgBMO5Eod7x0PQexLkOTZLwXb5t5ij8KE2QIGCcqcE3VWrwx5wkzOsz IAfAuBOFesfDYf53IFKEa+n8EDRpggQBI0wNfldIQZQS9BkA0oS2QUuPizSh2eXwrTRBgoDxpgbl 7oSYZ6DPAPBise5PiLNYyh0P0gQJAnYoNTggBQBaEoWTND0ESpogQcCOpgbkAEBboiBNkCBAagAA 0gRIEKQG5ACANAEShNGkBiEHUgMAQ0wT3iYnREoQsHI5iIlnTRJwL82ehig1ANCXNCG2TodcvJcm EASsTg7K1OBWTgaaw5V+nz4cqvQv+bYck3wrv79piADWKQmlKMRBTyEKR8ULlL1KEt6TBIKAC4rB 6S9O/OJdzb9wUU74uhCDmIYoNQDQxzThKF/1yZAnpSQQBYKA7qlB7FKIRsQoKZSNiI0k/C6nCVID AH1ME47S2fHt5b9J0gSCgAvIQbl9sVn8mybE32cpqM9QkBoA6GOaUIrCYZoeAndQCMIJSSAI6CYH 0W9wLScC80oKzd/dTuebgcgBgD6kCQfpfG9CvL1PEggCOohBS7/BnRY5KEsKH+V04TD/AhIDAH0V hehNKNOE+HerLDPoSyAIqFKDtn6DZjdC3W/Q/Pmz/PfX09maHjkA0DdJSGlacoht2iEKdUl0r5IF aQJBIAdpdr9BIwdlv4GSAoAhJgl7M0Sh7ElQciAIKOSgS79BDD76OJ3dpUAMAAxNFGpJiF0O+hII AlbQb3CQlBQADFMSUiUJ9S4HfQkEYadTA/0GAHZdEvaSvgSCgJlyECOT9RsA2DVJuGhfQlwkgSCM Ug7iPIUoKTRC8K9JvwGA3RSFRX0JcdBTIwbvSAJB2AU5+KaSA/0GAHZRElKa35dQTl18RxIIwpjl 4OMqOYhmRP0GAHZZEmb1JUSJNQThuJAEPQkEYdBycFDJwTdZCkIOmj835ynoNwCwy5Iwq+QQ/Qix u+GkSBI0LhKEQcpB24yDcqfCH/OfoxlRvwEAonBeEg5aJKHc/mgbJEEYhhjMmXFQ9hxEclA2I+o3 AIDzfQmlKOwX/1bG+9oGSRAGkRrMm3EQA5CanQpfV3Kg3wAAzkvCXiEJV6prP9kGSRAGKAdtMw5K OfiEHADAhSThsLpsgyQIg5CDLjMO7pMDAFhaEhoRsA2SIAxeDrrMOCAHALB8krDMNkiSQBB6Iwdm HADAeiRhmW2QJIEg9E4OzDgAgPWLQts2yH2SQBD6LAdmHADA+iUhpfPbIEkCQRiMHJhxAADrlYQ9 kkAQhiwH+g0AgCQQBHJADgCAJBAEckAOAIAkEITdozhbISYkxhCkP5EDACAJY+bAUzA3PWh+sJq9 tjfT2TkH5AAA+icJkfbO4n1x21yv0/ToaEgQlpaD5uCl++n8ECRyAADDShLizIbjMk34+PAP76UI BKGrHOzlH6pmwFEzBfHLFjlw6BIADEsS9gpBeHN6vS0kQamBIHSSg4MsB3fShyObf5/Onq0QExLJ AQAMQxLKkcyNGLwmCQRhWTmYdfhSyMFnhRwYggQAw5CEKDOkLASvC0loEgVNiwRhaTmIHQvNkc3N qYz30vRsBXIAAP2XhElxhSC8aUsRSAJBWCQH9ayDRg6+Sh+ObL6enK0AAEOShFIQ4r7Y9vg2X5Ei kASC0EkO/jXLQbODodnJ0Gx3LI9sBgAMJ0nYq5KESBOicdGMhIIDPzi/DUKaNevg63x/yIHkAACG 92998293k/42KfC9SghiLkJKZiRIEHJ6UE9JLJMDg5AAYHxJQkzIjZ0N8e+6GQkEwSAkAJAm/HrV kmBGwi4LgkFIALDzKYIZCQRhphwYhAQAJMGMBILwgeJ0RoOQAIAkmJEwh53ZxTCj76ApLfxTThC+ zsJADgBgdyThIP+bfztNywsv823IwU7ubNiJBGFOU2JMSWwSBIOQAGB3k4R6RsL7dHaY0s7tbBi9 IMxpSgw5+FM6P+vAICQA2B1JqAWh7Ek4yYKwc02LoxaEBU2JIQfljoXD6gcDALA7SULIQdm4uLM7 Gw524JteTkpsSgtfZCn4Jr8dI5QPJQcAsNOSUA7Pe59FYF5fwnEacT/CaBOEalLizZwSxDCkZseC 0xkBAHWKMG9nw6tUbX8ccz/CKAVBUyIA4BKSUJ/+WKcJZZIw2lLD6ARBUyIAYEVJwl46f0T0zkjC wUi/uc3X1ZQWmn2tUVr4ffow8+DLnCjcSE5nBAC0ryP16Y+NEDQlhhen1/P89qj7EUaVIBR9B83C f6uQgyY1MCkRAHCRJKEuNexEP8JoBGHBCY2aEgEAF2EyQxJGX2oYjSDkcxbKvoMvkqZEAMBqUoSd 60cYRQ9CVVqIeQeNEDQ9B01Z4fMsDeQAALCsJOxkP8LgE4SitNB885rSQrM7oe47iOObTUoEAFwm SdiZfoRBC0K1pTHMrtml0JQUmtJC9B3cTfoOAACXY6f6EYZeYii3NN7K6cGXOTX4OicHd7Ic2LEA ALhsihDHQ98p0oO4XpYpQpaFwZYaBpsgzNnSGLsWfpemhzAZhgQAWIUkzDoa+rgQhUgSBl1qGKQg dNzS2DQm3k3TeQf6DgAAq0oS6lLDcZoe6hSSEP0Igyw1HAz4G1TGPJ/mxOAPadqUeCedHYYEAMAq 16CyvN3saHiar2dpurNhsKWGwSUIOT0oRyk3kxF/n86es9CUFpyzAADYVIqQChkoU4TBlhoGJQi2 NAIAeiQJe5UwNIJQ9iK8TAMuNRwM8BtSlhaiMbERgy+zMNzKcqC0AABY95pUD+lrSg1P0rTcMNhS w2AShBmlhWZSYllaiFMaTUsEAGw6TYiGxVGUGgYhCHNKC7Fr4Zv0obRgSyMAYBtykFJ7qWGwuxoO BvQN2E9nO0a/ymLwRU4ONCUCALa5RpWlhuaMhsdpWm5oSg/NEKU4r6H3pYbeJwgtA5GapCBKC3/M kqC0AADoS5oQa9BxloIX+fqtH2EIpYaDgTzhkR7czunBF/mqRymTAwDAttaqSV6LrqXpjJ5Hp9dP p9cvaTofIUYx9zpF6HWCUDUmNk92NCbGtMRGEu5VggAAwLYThL007UV4PcQUobeC0NKYWI5TbnYt fJPTBKUFAEBfiSOhGzl4mW8H0bDY5xLDrMbERhI+z8nBdXIAAOjZ2hUvbq/ntapZs5pSQzQsDmI2 Qi8ThAWNiX/KovARQQAA9FgUYl16XyQJg5mNMOnxEzurMbGZnqgxEQDQ9xQhGhbv5he6X+Xr03zf b+tYfmHcK3pXYqjSg5s5Kfg8P6mf5z+beQAA6LskDHo2Qq9KDBoTAQAjFIUusxHe9a1h8aCHT6TG RADAWORg1myEH0+vn3Oa8DJNmxV7kyL0JkEo0oOQA42JAICxJQjvsww0ycHzfPVyNsKkZ09iW++B xkQAwNAloVnfjvIL4KZ8/lm+7uf7jlLP+up6kSDM2dYYExO/TFXHp583AMCABKG8LU97bBKEXk5Y nPToyRucXQEAsOQ61ykl78O2x603KVbpwY38pH2WU4PPcnKg7wAAMHRB2EvnJyw2hzjF1sdebXvc aomhw7bGr9P0KOerBAEAMBJRSGk6YbHtMKetb3uc9OCJ6rqtcY8cAAAGLgf1tsemvPBF6uEgwK0l CLY1AgB2OEHosu1xqynCZMtPkm2NAIBdlIS2xvxP81p4ow8pwlYShDnpgW2NAIBdEITyttn2GCc9 Pu1LijDZ4pNT71z4NNnWCADYrRShXgd7kyJsPEGYkR78LqcHv08fSgx3C0GQHgAApAgbThEmW3pS em1NAADs+nq40QRBegAAwDBShMkWngzpAQAAPV8XN5YgSA8AABhOijDZ8JMgPQAAYADr40YSBOkB AADDShE2uRCXdnRPegAAQKcU4V61Tm6EyQY/TxxOcTt9GKX8eZqOVHYgEwBg1wWhPA76TrVW3k4b ni689k9SHekcp1d9nL/gxop6c3IVAAA9SRFu5jXyk7xmxvlEvx5emNfWwScI5ZHOcShTE5ncL4xI egAAIAjTFCES9/tpWo6/mdfSjbygXqsgFOlBE4nEqVUf5atpSoyaitMaAQD4sBZO0rQX4W6xbsY5 RQebSBEmfflCCQIAAKk3L6zXJgjZbHoTlQAAMCBJ6FSaX2eKsO4Eod7aGM0W5RcoPQAA4HyKUL7A Lpv7N7LlcbLmjx1bG2PnwmfpbDfmxrZrAAAwILa+hq7lA7dsbdyK/QAAMGA6pfDrKjOsyzxsbQQA 4HLr6Fb7+FYuCLY2AgCwMknY2pbHdSUI8QXFuEhbGwEAuJggtL3gjmMKrq5rLZ+s6WPGFxORSDlW 2dZGAAC6S0JZso9ehCjZly+6+ysIM5oT76fzvQfSAwAAuqcIC9fVVZcZJmv4QrZiOgAAjJStJPMr W6gXNCeuvVYCAMDIJWFhb98qU4TJNr6ApLwAAEBXtvICfLLij6U5EQCA9UjCRkv4K/lAmhMBANhI irCxZsXJCh+45kQAANbHRpP6dQlCTHtqvgDNiQAArE4SotfvdppOKe6fIFTlhaMiQSgfsOZEAAAu /2I8UoTyBXkkCEdphWWGyYoecHniVPNgm9jjTtKcCADAqiWhTOzv5DW3POtoJWvuZMUP9kZ+sM0D vVXaDEEAAGBlKUKk9rfymnsnr8Ere1F+KUFoKS+s7YECAIDuL8wvW2aYrOhBXi0e5P1CEFYWdQAA gM2tvasSBOUFAAA2JwhrT+8vLAjKCwAAbD1FWFuZYbKCB6e8AADAdgRhbWvwKgRBeQEAgM0LwlpT /AsJgvICAAC9SRHWUmaYXPJBKS8AALBdQVjLWnxZQVBeAABge4KwtjR/aUFQXgAAoHcpwsrLDJNL PBjlBQAA+iEIK1+TLyMIygsAAGxfENaS6i8lCEV54aAShOZM6utJeQEAgG2lCId5Lb5dCUKzZi9d ZrhIghCmci2byr1CEJQXAADYjiBcLQThXl6jr6Vpsr++BCGdjTKaT3ozP5DGUo7CUggCAAAbFYRI 94/ymnw7r9GlIKw1QSgt5Sh/8ngA0gMAALafIlxbxfrcWRCq/oOIMW4V6YHmRAAAtpsizE34l+lD WDZBCEGIT36nMJSDdPnjowEAwMVYaY/gMgt6vZXiRn4A8Yn1HwAAsN0EYWW7DJcVhLb+g6Ok/wAA gD5Iwsq2O3YSBP0HAAAMRhBWst1xmQRB/wEAAP0WhJVtd5ws+Un1HwAAMIwUodzuuHQ7wOQCn1D/ AQAA/U4RZr2gb9brTn0ICwVB/wEAAIOircxQrtkrTRD0HwAAMJwEIV7UX8tyUE5U7PSifrLEJ9N/ AADAcFKEZt2OLY9Hy67ZXQVB/wEAAMNMEY7SdFhS562Oc9+p6D8o91XqPwAAoP+CUO5mKMsMnQYm dU0QyvJC2/HOAACgX5JwqbV70uETLLQQCQIAAL1NEC6U/ncVhEvVMQAAwMYl4VL9g10W+Et3QgIA gK2kCBcemDRTEKoBSeUnWHovJQAA2DhtA5OiCnCQVlBiOKjso2xyIAcAAPQzQajLDEtVASYd4om6 QTEaHJQYAADotyTsp7N9hIdd1+8ugqBBEQCAYacIV/JafjW/vV/8/dKCEH+vQREAgOFKQrzYP6zW 8f2lBUGDIgAAo5KDtj6EXwVh1k6GRSWG/SI9iO0RnbofAQBALySh7CW8Vb3YX7rE0Mk6SAIAAL2W gwvvZOjapLhU3QIAAPQqQVh6J8Okg3Us3fkIAAB6lyIstZ5PVm0cAACgd5KwdEXgnCDkbsZLTV8C AAC9k4OldjIsShCW7noEAAC9k4Sl1/TJjA9U1itK29CDAADAsOTgQmt6lx6EmKTo/AUAAIYpCZMZ a/pSCUJtHAfVByIIAAAMTxDa1vSldjFc6AMBAIBeS8JSL/wnq4oiAABArwVhqdaBM4JQbXHUoAgA wLjSg5lre73VcTLHMmxxBABgXAlC57V9chHLIAkAAIwrQajX9i49CDGz2RZHAACGKwlLre3zBiVN ig82KT4AQQAAYJgpQue1fdLxA5EDAADGJQlz1/bJZT8AAAAYnyRMFvyPygsAAIxTDuau8W2CoEER AIBxCkLnNf43QTAkCQCA0acHnYcltSUIhiQBADBOSei8xk+WtQuSAADAOBOEco3XgwAAwO5IwvI9 CJVh2MUAAMA4U4QL7WJo+wDkAACAcUrC0pMUAQDADkMQAAAAQQAAAAQBAAAQBAAAQBAAAABBAAAA BAEAABAEAACwAToNSyIIAADsrhzMHLdMEAAA2C1B6HRg06LDmpzDAADAuNKDuUc+/9utf9+rBcFJ jgAAjF8S9nNycO30upVvr4YgtCUIS50TDQAAxpcgxHr/qyDkOKHz/wQAAAYrCUv3IHSOHQAAwKBT hM67GCQIAADspiQsnINQxg4HOTk4SHoQAADYOdp2McyyCoIAAMAOCsL74joprvJ+AACwg4LQCMFx vt4Ub58QBAAARsG8MOCcIMRfvDu93p5er06vF/n2bb5figAAwLjk4HiWJNQJwrucHLw8vZ7m2zeF IAAAgGELQojB27zGv00t1YJfBeE/n/6HBAEAgN1IDzqt9ZOLWAUAABisJHSqFrTtYlhYlwAAAONM EHJV4dxxz506GwEAwGAloXsPAgAA2KkUYaldDAAAYPckYe4cBAAAAIIAAAAIAgAAIAgAAIAgAAAA ggAAAAgCAAAgCAAAgCAAAIBBCILzGAAAGCed1/hFhzU50REAgHHKwdw1vk0QOp3yBAAABicIndf4 SYtZzD0nmiQAADDY9KDzGt+WILzLVvHy9Hqab98U/zMAABimJHRe438ThP98+h8SBAAAdjhByC4w M0HQgwAAwDgl4UI9CKVh2MUAAMA4U4QL7WJo+wDkAACAcUpC5zkIJAEAgB2Xg64JgjIDAADjkoOF a/ssQdCoCADAuARhqbV9VpOirY4AAIwrPVhqbZ+VIBiWBADAuCRhqbX9jCAYlgQAwG4mCOWQpHkJ QlmneJ2mdQoJAgAAw00Q2tb2Tj0IpSCUH+hYegAAwChShHpt7ywIF/pAAACgt3Kw9Av/yaqiCAAA 0GtBWKp1YLIgPdCoCADAsOXgQmv6ogTBVkcAAIYvCUuv6ecEodrq+KayjTdJmQEAgCHJQZQX2tb0 1i2OXRKE8gO+JgcAAAxaEl5XL/iX6kGID1bWLN6k6dxmPQgAAAxHDi60nk9WbRwAAKBXgnChisCk gxzMrFmQBAAABpEeLN1TuChBeJdNo/mAT/NtmAc5AACg/5JwPGMtf7d0gpC7GcuhCo1tPE9nt0Vo VgQAoN9ycJLObnF8nqYzEH5NENp2MCxKEFL+wG8L87DVEQCAYQlC3S4QkxRP5v3Pk3V9YAAAsHUu /EK/iyDMjSakCAAA9Do9uFCrwKTDJzguPvDTQhI0KgIA0G9JuPAaPlMQNCoCADD4BOFCDYpdEoSU NCoCADBUQbhwH+Fk3Z8AAABshUu9wO8qCHVE8VKKAADAINKDeu3u1CIw6fiJyh6EJ+lsk4MUAQCA /qUHxzPW7rddXtjPFYSiUTEShBjTWH4SCQIAAP1LEMoX9zFi+bcEYV6D4jIJQnnQw7N81Qc3AQCA fgjCpdftroIwz0T0IQAA0K/0IPoPLpz8Tzp+wvhkL7OFPM63L5M+BAAA+sRK1uyFglANTNKHAABA /xOEuan/ov6DZRIEfQgAAAxDEFayXi8jCPoQAADof3qwksR/ssQn1ocAAEC/Wdla3UkQ9CEAADCY BOHS/QfLJgiz6hrl6EaCAADA9gRhZf2CywpCmElEF21jl0kCAADbSQ9WlvRPlnwApSA0n/iXLAkv pAgAAGyVlfYKdhaEqg/hdbaSx4UgvCYIAABsNUFYSf/BRRKEqG/E2dJPsiQ8z/cpMwAAsB1BiP6D SBAuNa9ocokHEILwS7aUl2la4wAAAJtND+rjnZ9Va/P6BKEqM6zsQQAAgJWkByt78T655AMpYwzb HQEA2J4gzC3/L9N/cBlBsN0RAIB+yEHZnNikBo8qQbjQC/fJBR+Q7Y4AAPQnPXiTprsLfy4E4cJr 8tKCYLsjAAC9E4RyPX6UX7z/NiBp2fLCZRKETg+IJAAAsFY5WEt5YRWCsPJIAwAAbH8tvpAgFGWG tVgLAADoLAgrLy9cJkHo/MBIAgAAa5GDtb5QX4UgKDMAALCd9GBta/CFBUGZAQCArQvCWsoLl00Q Oj9AkgAAwErlYO0v0FclCMoMAABsNj1Y69p7KUFQZgAAYGuCsLbywioShM4PlCQAALCSNXcjL8xX KQgRdTQPNKKOZ1IEAADWkh48S9PywqO04tL+pQWhpczQPOBf8oMNQXDCIwAAq0kPjgtBeJTX3Gdp heWFVSUIbUbTPOCH6ewJjye+twAAXIqTvKa+yGvsw+oF+coS+3UJQmMzP6YPsceTbDXHJAEAgEvJ wXFeU5/kNfbHIkHonyBUZYaXxQMPQXiZNCsCAHCZF+Kd1tlVlBdWmSBs3GwAANgxQdhoUj9Z8RdQ 1kaazsqH+XpaPXiSAADAculBvAh/Wqyvj9Oaev1WJghFmWGjXwAAADtApxfgqyovrCNB0KwIAMDq 5WDjJfyVCoJmRQAAVv7Ce6PNietKELZmOgAAjFQQtpLMT9b0BWlWBABgNenBVnr7Vi4IC5oVy1nR BAEAgMWCUJ51tPbmxHUnCHUk0nwxD9L5msl7kgAAQOs6+j6d7z14kNfUtZfs1yIILc2KTRTyUzrb i/Am6UUAAGDeC+036WzvwU95TV1bc+K6E4SUpmWGMJ/mC/tHvo3aiRQBAIDZ6UH08pVraCTxax0b MFnzFxn28zzbz4M0jUdWem41AAAjYtb6+Uu1fq6N/XV94J/f/Dl9fPiHvfzHvfy5Dk+va6fXrdPr Zn776ul1kN9nz88EAGDHiRJ9U1poSgrfnl7/7/T6S04RmmbFpkFxbeWFTSQI7ysLergNCwIAYCD0 podvrYKQzWbrdRQAAAYkCJ12Aa4zPdhEglCnCHM7MZNeBACA9KAXc4TWLghVirCVvZwAAAxIELYy GGkbCcJSXzRJAADsqBz06sX0RgTB+GUAABYKwlYHI20rQSi/eOOXAQBoTw9609C/MUEwfhkAgIXp QW9GAkw2/CTMGr/8IJ0dv6zUAADYxfTgUV4bv8+3j4q18f2mygvbEISUZo+PbEoN0bAoRQAA7Hp6 sNVjCfY3+clmjF++kj6MXG5GL19P0/HL+1lgjF8GAIxVDmKH39OcGDRjlf8nfRir3KQIj9MGxiq3 cbBlW4pmxabM8MnpdS99OKfhKD+2CUkAAIw8PYjdfU2S/kPqyaGG+5v+hFWKUCYJh1kMbqSzhzgR BADAWOWg2dn3JItBpAd/zi+ct5YebCtBqJ+Yxpqa3Qx/O73uFClCIwlXsjy8JwkAgBHJQdm0H9sa v89iEIORtrqzb38bnzSnCKlKEQ5yinAjC8L1dLbUQBAAAGNKD5p04FEWg/9N0yOdf8ipwuttpQcp bWcXw6/kL7ju3GyelL/n2zNbO5JdDQCAcchBua3xl5wa/DV9SNKbRP1p6sEZRZMePFG9bdAAAGBN 617dqB9zD2Ks8sYOZZrF/jafparUUDYrNv0HTZnhZjrbsLiXlBoAAMNOD8ptjf+Xpo2JjSQ8CkHY phz0IUGobapXQyIAANjAetck570bFri/7QcwY3jSrBRhX4oAABioHHQdivRu2+lBXxKEwVkVAAAX XOcG03O334cHYQQzAGAH5KC3Q5HaOOjhE2gEMwBgTHLQ+6FIvU0QWlKEMkkwghkAMPT0oNdDkfqe IJRPZJcRzCEIJAEA0Of0oPdDkXqdIBQpQqpShBjBfL1IEYxgBgAMQRCitNCUEppJwX/O6cF36UOp oRGEX8sLfUoPeicIMyRhkmUgygxxRoOGRQBAn+WgbkyshyI1iUJTejjumxyk1L8Sw6wn9qf8ZH58 et1NGhYBAP2Wg7ox8UFex77Pa1r0HfR2+/5+Hx/UjFLDfk4NGjG4JkUAAPRYEEIOmpQgSgsxFKls THzXx/SgzwlCnSKUDYu304emxRvpfC8CSQAA9GHtii37P+fU4Ls0gMbE3icIM1KEeLwxQCmGJx0m uxoAAP2Qg9i18DzLQSMFsa0xGhN/m3vQ1/Sg14LQIgnv8+I/yUJwlCWhEQSlBgBAHwShLC3EzINy YmIzC6G3jYklBwN6wpsn9HEWg1v5up2muxqUGgAA21yr6tJC03vwbU4RfkzTccrHaQDnCu33/QHO KDVEiqDUAADogxyMprQwGEFokQSlBgBA3wRhNKWF4GCA3wClBgBAn9amUZUWBpUgtKQIgVIDAGCb cjC60sLgBKFFEpQaAADbFoTRlRaCgwF/Q5QaAADbXItGWVoYZILQkiIESg0AgE3KwWhLC4MVhBZJ aCs1xFkNV4okIZEEAMAK5CCS7Bfp/FkLgy8tBAcD/ybVpYabaVpuaJKEq/lr3CtuAQC47NpTnhMU pYW/phGUFgadILSkCMEki8BRvg7TtNSwn5QaAACXk4OmtBB9Bz9mKRhVaWHwgtAiCfFNiLTgaiEI kSToRwAAXEYO2voOorTwQ5keDFkOUhp2iaH8ppWlhkYGrhUpwlElCFcKkQAAoMs6U681jQx8m8Wg uX2QRlJaGEWCUKUI74srBCCaFiNFiF0N5iMAAJZ9Ifq6kIP/y8lBU1poygxNL0KUFk6Gnh6MQhAq SUiVIOxnOdCPAAC4qBws6jto0oMnaQR9ByUHI/smhuE9KdKDG2k6POkwne1FkCQAABbJQdN3EFsa my2M3+YEIQYiPclrzyhKC6NKEKoU4X11RZJwNZ0tN8Qo5kQSAAAtclCPUv57Tg7+O982gvAwy0Mj Ee/Hkh6MShDmSEIIQN2PcEASAABzBGHn+g5GKwiVJKTU3o9w2CIJ+hEAAOXasZN9ByUHI/7m1v0I jRREL0KdIBySBABA2vG+g1EnCFWKUPcjpDSdthiDlMrzGkgCAOy2HOx038HoBWGGJJwUb5cHO2la BADMGoa0U30HOyEICyQhxjG39SOQBADYTTl4l6aHMO1k30HJwY584+Ob/qwQg6YfIU59rOcj7JME ANgpQSjloEkJmlLCX9KHUcpxSuPo+w52JkFYkCKkNO1HuJKmvQj6EQBgt+Sg3LHwU5EcxCFMTR9C 048w+r6DnRKEGZJQz0jYLyQhRMH2RwDYDTmIExofVnIQTYk/578ffd/BzgnCnCQhrlIS7GwAgN2Q g3rHwvc5MWh2LJRNiU93TQ52ShBaJCHk4F06u7OhbFzUtAgA45aDesdCyEHTlPhjloPXsVY068iu cLCjPxhlM0qdHlwrUoRIEA5IAgCMSg7K5vWfc3rwXb6+z/c9K+Vgl9KDnUsQWlKEtkOd5o1jJgkA MA45eJWmOxbKvoO/pA+TEx+lD6WH412Ug50UhBmSsGhnwz5JAIBRy8F/ZznYyR0LBKFbklA+Nwck AQBGKwffFXLQNBfs7I4FgtAtSahHMu+TBAAYtRz8b9qxMcoEYXlJiF0NcZEEANgtOdjJHQttHPj5 +e2HKDpa9zou/kfJSGYAGMq/7fWUxJCD79J01sGrtKM7FiQI3VOESBKO07TkEM2L0ZcQMxIMUgKA fsrBrBHK5IAgrEUSyrHMRjIDQH/loB6h3NQM/oscEIR1SUIkCEYyA0A/5WDRCGVyQBBWKgnRtLiX jGQGgL7LQZcRyuSAIKxMEk6K561t2iJJAIDtykE5Sr8Rgeg7aOTg29Prwen1hBwQhFVJQteRzBOS AABblQMjlAnCViShbSRzOW0xBGEv6UkAgE3KwXGRHBihTBC2miSkQhRid0MtCEmaAABrlYOTNO05 aJMDI5QJwsaThPJKlQxMKlkgCQCw+tQgtjI2JYOmIfHHdH7WgRHKBGGjklBufzzOP6Cx06EtVSAJ ALBaOXiXF/wmFWhKBz+0JAdGKF8Co5aX/8GMDtn4c9S9GoN9mm9f5/vjB9lYZgBYrRzE+ORSDr7L YtDsVvh7IQd2LEgQtpIivM0W+7oQg0gRoonRAU8AsDo5eJXOjk8uhyD9JcvBz3VyQA4IwjYl4U2a lhuixEASAGC1cvB0hhw0ycE/cqoQDYnkgCBsVhJOr/enolD3I7wtBOEkTWcmOCoaAFYvB02/wX+l 6YTEZghSM+fgRZaDE3JAELadJtTnNsw64IkkAMDl5eC7dP5UxmYHQzMh8WV+ofbrbgUNiQShD5LQ 9RRIkgAAq5WD8uAlExIJwigkwWhmAJgtB/V0xEVyoN+AIAxeEmpBMJoZAKZysGg6IjkgCKOShLJx cZLOT1s0mhmA1GC56YjkgCCMShLepbNnORjNDIAcLD8dkRwQhNFIwnEymhkA5slBTEd8eHp9f3r9 Xzp7XPPfkumIBGGEkhApQjl1MfbpxvdiP2leBLB7ctB2VLPpiARh5yShbTRz2cCoeRHArsjBomZE 0xEJws5KQoxmjhRB8yKAXUkN5jUj/k8yHZEg7IokLBjNXG6FLGVA8yKAMcrBvGbE/0nTnQqmIxKE nUsTTmaIwqzmxfIiCQCGLAfRbzCrGbFZ/aMZ0XREgrCTkrCoefFdkSLoSwAwdDlo6zf4Wzrbb/CX NG1GfJo0IxIEkjC3ebGt1KAvAcCQUoNFw480IxIEdJSEaF6cN1Qp3iYJAPosB5GQzus30IxIEFBL woLmxTfp7ATGNklQcgDQRzmIkkL0GzRlg7rfoLn9W9KMSBCwME04SbNLDiELZZrQliIQBQDbTg3i 37AmDYiSwt/S2S2MzepfDj/SjEgQsEAS2koOr7IkxMyE+CXcm3MBwDZTg1nnKbT1G2hGJAi4oCS8 LZKEmJtwXIhCmiEHRAHAplKDshHxSZpdUoj5BvoNCAKWlYSWvoSy3PBqRqLQoIERwDbkoG5EfJDO T0WMksJPWSBeJf0GBAGXShPK0yDLksPLKlFISQMjgM3KQddGxGaXQlNqeJjfL3qqpAYEAZeUhDpN eF1IQqQJGhgBbDI1mNeI+N9FahC7FB6naUlBvwFBwCokYUbJ4XU6W3LQwAhg06lBl0bEcpeCkgJB wBrThLaSQ9cGRmkCgFWkBl0aEWPwUUxFVFIgCNhCmjCvgfGkkoRaDIgCgEViMCs1mDXbIBoRY/DR O6kBQcD204S2Bsb36WzpoRYGkgCgTQ7ihcibDqmBRkSCgJ5JwrwGxmhiLEc216WHtlsAUoP4N+VV XvDbzlHQiDhiLAgj4N9u/XvsWDg4va6eXtdOrzun1/3T69PT66vT65vT64t8NfffO71u5fe9mqZH SksUAKnBcZEaPM1yEMnB9zktaKTgQb7/cX7feDFyQgwkCOhXmnBS/XJHmvCiuF6Vdp+UHQDMbkJ8 mIXg2yo1+Ev60GtQT0RUUpAgYGBpwq2cGNwvUoSvc7LwSb6/eZ/rp9dh/n/3iQKwM2JQ9xo8zsnA g5wUfFekBz/nROGp1ECCgHGkCWVfQiQJr4s0IRKFlOx2AHZFDN6n7k2I3xaC8ERqIEHAONKERgSv 5HTgZvrQn/Dx6fV5ThO+yref5/vv5Pc7zP9f2Z8AYPhyUG+TfpETgYdVatDcRimhSRWepekOqXdS AwkChp8mlI1H5U6HF/kX/kU623lstwMw3tSg3p3wKAvA33NK8Od0dutiTEN8mqbTEO1QkCBgZGnC XpbCg5wOND0HTe9B04PwSU4Svk52OwBjFIO6zyB2JzSpwQ/5+nsWgub6KctDjEk+JgYEAeMXhVWV Hex4APovBmVqEKcuPs4CEDLw90ISHiZNiEhKDDvHJcsOcRhU/P+1HBAFoH9iEE3KkRjMGpFclhM0 IcI/6NKEpcoOn+X7755eN/L7XpUoAL1NDKIBsTk/4VFe/BtBaHYj/DVNJyA+zAIRUqAJEf4hR+ey Q3N9mSWhmc54jygAgxGDJjl4kNr7DNp2J7yXGsA/4KjThBCFesjSR4UcfJFviQIwDDF4kFODkIS2 PoPfyojEAAQB80ShLjvczCJwr5ADogAMRwwe5PtjZ8KLnBrYnQCCgKVFoSw7XM0L/w2iAAxWDJ4n fQboiF0MaKXa7fAund/t8DxfT/OrkeaK46Xf5ivGPcfHMb4ZuLgYlHMMYldCDDmKA5XKIUfN200j YuxMeJx/Z18Vv59SA0gQcOk0oSw9LJsoxAyFGLYUh0FN8uVnETgvBamQ7JD0GHIUswwukhhoQARB QG9E4ZN8/+38fkdpOnCpPjnSzySkBfOTuydZAH4kBiAIGLoofJ4lISYy3ioShUgVrhSJAlHAropB JAZvi7QgEoOnaToBsZGDfxADEAQMXRRCDhpZiPMdPsqyEKmC8gN2UQpSml1GiLSgkYLYlvhzFoKQ BGIAgoBBi8LtLAMfZTm4n2Xh43zNKz9IFTD2tGBeGeGnfD3IchCHKz3O70MMQBAwaFE4StNZCrfS dEJjkyx8lmaXH45aUgW9ChhbWvAqzS4j/JBvY+Jh7Bp6kf8/YgCCgEGLwkGajnA+KlKFe0WKUJYf 7hWycL0QhZinoASBsaQFLwop+CWdLyP8lO+LtOBVmo5EPiYGIAgYsiikYjEPWYgxzrPKD5/k2/v5 72+ls+UHJQgMQQred0wLfs7Xj2l2GaE8dvldIRyJGIAgYCypQizoVwpRaK6y/HC/EIVGHO7mK0RB CQJDkIJy2uG8tODHQhLKMsLLQgzKwWPSAhAEjFoUZpUfrheiEGObI1ko/9ylBEEWsE0pKJsOn+Y0 oC0t+KUQg+gtUEYAQcBOi0JK7eWHoyJVuJFFIFKEj9LiEsQ8WfBzj8sIQVpCCp7nJOBRvh4uSAui 6VAZAQQBqFKFkIUyVSgbG29lIZhVggihqGWhnq0gXcBFU4K2XQizpOBxvo2k4FGHtEAZAQQB6Jgq tG2XnFWCuJvvL2XhepUqlOOdpQtYJiWIHQhlWvBijhSUf35avJ+0AAQBWEGqUB47vagEEXIQshA7 JK6naa/CtSKZWJQu+B3ZTSGYlRK8Lhb3F/mKnQZtUvCsSBVeFR9DWgCCAKxYFhaVIGKHQ8hCpAy3 8/2xU+LGjHThgDAQgiIpqFOC+njzmHb4eIEUlMOMpAUgCMCaRCGl2SWIUhbKyY0hBzGc6U6VLlwr 0oWrhGGnheBNkRK8rFKC2J74pJCEcrLhIimwEwEEAdhgqrA3RxYOi8U/ygylHJTpQqQPUYpYVhgS aeiVDKQLCEGUDiIFqFOCkIQoL4REvCYFIAjAsGQhShGlNMQBUjeqdCEaH29dQBhm7Y4gDpsTgVm7 DZYVghhk9LRKCaJs8KKSgXJWASkAQQAGJAttcxbqdOFampYkbiwhDEeVLOynszskysfRJg7k4fIi EG+XOw3eVVLwagkhiPtfpLOlhjIlqHcekAIQBGCAspA6pgtXC2E46igMN9J0V0R8jKN0fitlec1K GmbNZRirQNSLf/13i0SgvkIIXhVJQew6eN5RCF4VQvCmS0rQPFhSAIIAjD9dOFhSGG6naUPktSKJ qHdGRGrRdhplLQ97Ha4uv9Ob/t2et+DPW/zLK6X2+QNtIlC+mq93HMQZBtE4+GRJITiWEgAEAdKF iwrDtSJBCDGIvoYoQxymswOeDtP5csSVSh4m1eOZJRBtv8sXEYpViMG8Bb/tfevF/yS1n2uwSARe pbOTDOMwpOeVKMRpiBcSAikBCAJAGJYVhnLgUnnY1FHLfbdaJKFsnKwlYbJAINrkYBmhWKUczFvw 6/evF/9yaFBZRnjbQQTKUcXliYnlfWXvACEACAKwdmHYLxbtsp+hnNB4pUUCrlYLfykPUZaYtLxP KQltgrCMUKxSEBYt+PX714t//D/lYh3TCxeJwOtq0X9TfLyyb6BtSBEhAAgCsDZhmJU0lK/iD9L5 rZH7cwQgtk2GXNQCEX9fpwf7SwjFKgVh3oJfpwizFv836ezo4baPWYvAm3R2R0G9i6EWAUIAEARg K8KQKmkoF+62XQzx51oeyr+ft+CXv7uTQkQWCcUq6bLglzLRVSji476dIwLlVe92OKk+JyEACALQ G2ko5aHtmtWEWErGLIFoKzEsIxSrSg+6LPj1/9O2+M9rVJwnAm07IMgAQBCAwYrDInlYtulwWaFY pSQsWvDbpGJRU2OXrZBEACAIwM7JwyKBSDPet++7GLos/vX7EgGAIABYQiDSJYRiHZLQZcG3+AME AUDPhWIdomDBBwAAAMbM/xdgALwnY3SUzGcNAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 6.4286 26.7624)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.6069,
    y1: 102.2957,
    x2: 442.2915,
    y2: 459.9803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#70FFDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0663307,
    style: {
      stopColor: "#5ADCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    style: {
      stopColor: "#43B7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    style: {
      stopColor: "#2F98BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3438,
    style: {
      stopColor: "#1E7EB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4534,
    style: {
      stopColor: "#126AAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    style: {
      stopColor: "#095CA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7314,
    style: {
      stopColor: "#0453A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    style: {
      stopColor: "#0251A5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.4,28.1c-139.5,0-253,113.5-253,253c0,139.5,113.5,253,253,253c139.5,0,253-113.5,253-253 C516.5,141.6,403,28.1,263.4,28.1z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3_",
    className: "st2",
    cx: 260.2,
    cy: 277.9,
    r: 190.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.5599,
    y1: 122.2488,
    x2: 421.0679,
    y2: 438.7568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF811"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    style: {
      stopColor: "#FFD41C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2602,
    style: {
      stopColor: "#FFBA23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3336,
    style: {
      stopColor: "#FFB026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    style: {
      stopColor: "#FAAB26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6585,
    style: {
      stopColor: "#C07421"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8813,
    style: {
      stopColor: "#9D521E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F451D"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2_",
    className: "st3",
    cx: 263.4,
    cy: 281.1,
    r: 219.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.7958,
    y1: 176.4846,
    x2: 367.2655,
    y2: 384.9544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F451D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1187,
    style: {
      stopColor: "#9D521E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3415,
    style: {
      stopColor: "#C07421"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    style: {
      stopColor: "#FAAB26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    style: {
      stopColor: "#FFB026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7398,
    style: {
      stopColor: "#FFBA23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8631,
    style: {
      stopColor: "#FFD41C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF811"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1_",
    className: "st4",
    cx: 263.4,
    cy: 281.1,
    r: 144.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.8214,
    y1: 287.1049,
    x2: 303.2354,
    y2: 287.1049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6CE69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#D99A26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2361,
    style: {
      stopColor: "#D99A26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    style: {
      stopColor: "#D99A26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    style: {
      stopColor: "#DEA732"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F0D258"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    style: {
      stopColor: "#FBED6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    style: {
      stopColor: "#FFF778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    style: {
      stopColor: "#FDF274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    style: {
      stopColor: "#F8E368"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    style: {
      stopColor: "#EFCA53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    style: {
      stopColor: "#E3A837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DB9125"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.8,203.8h73.4v33.4h-30.1v31.6h26.8v31.7h-26.8v70h-43.3V203.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.825,
    y1: 329.035,
    x2: 318.18,
    y2: 220.9349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA6A1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02034385,
    style: {
      stopColor: "#B2631C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#904210"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#772B07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3107,
    style: {
      stopColor: "#681D02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3837,
    style: {
      stopColor: "#631800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4488,
    style: {
      stopColor: "#6B2100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5531,
    style: {
      stopColor: "#803800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    style: {
      stopColor: "#9A5500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C4B00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.8,199.1h73.4v33.4h-30.1V264h26.8v31.7h-26.8v70h-43.3V199.1z"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.7,144.4c-6.5-1.8-12.8-5.3-16.7-10.8c-5.1-7.4-5.3-16.9-5.1-25.5c-0.1,10-0.2,21.4-7.4,29.3 c-4.1,4.5-10,7-16,8.2c-6,1.1-12.2,1-18.3,0.9c6.5,0.4,13,0.8,19.2,2.5c6.2,1.7,12.2,5,16.1,10.1c5.6,7.3,6.1,17.2,6.5,26.4 c-0.2-6.6,0.3-13.3,2.7-19.5c6-15.6,24.2-19.6,39.2-19.4C131.1,146.3,124.3,146.1,117.7,144.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -289.2245,
    y1: -71.2734,
    x2: -274.002,
    y2: -62.1399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005347992,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07033272,
    style: {
      stopColor: "#949494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1081,
    style: {
      stopColor: "#9C9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1389,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1906,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2131,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2179,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3283,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3925,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4447,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5574,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M416.4,344.5c-3.2-0.9-6.4-2.6-8.3-5.4c-2.5-3.7-2.6-8.3-2.5-12.6c-0.1,5-0.1,10.6-3.7,14.5 c-2.1,2.2-5,3.5-7.9,4c-3,0.6-6,0.5-9,0.4c3.2,0.2,6.4,0.4,9.5,1.2c3.1,0.9,6.1,2.5,8,5c2.8,3.6,3,8.5,3.2,13.1 c-0.1-3.3,0.1-6.6,1.3-9.7c3-7.7,12-9.7,19.4-9.6C423,345.5,419.7,345.4,416.4,344.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyLogoBg);
export default __webpack_public_path__ + "static/media/money-logo-bg.c2a54f0dbce96e7c300492cec425e09d.svg";
export { ForwardRef as ReactComponent };